import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FaxFormSelectionComponent',
    props: {
        faxForms: {
            type: Array,
            default() {
                return [];
            },
        },
        faxSubmissionFormDetail: {
            type: String,
            default: null,
        },
        isEditable: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    emits: ["updateOrderInfoField", "update:optedIn"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const useFaxForm = ref(!!props.faxSubmissionFormDetail);
        const selectedFaxForm = ref(props.faxSubmissionFormDetail);
        const faxFormRules = [(v) => !!v || "Fax form is required"];
        // The parent clears the store field on its own (patient-search prepopulation, draft load) —
        // follow the prop so the checkbox and select never show a selection the store no longer holds.
        watch(() => props.faxSubmissionFormDetail, (value) => {
            useFaxForm.value = !!value;
            selectedFaxForm.value = value || null;
            emit("update:optedIn", useFaxForm.value);
        });
        function onOptInChange() {
            emit("update:optedIn", useFaxForm.value);
            if (!useFaxForm.value) {
                selectedFaxForm.value = null;
                emit("updateOrderInfoField", "faxSubmissionFormDetail", null);
            }
        }
        function onFormSelected() {
            emit("updateOrderInfoField", "faxSubmissionFormDetail", selectedFaxForm.value);
        }
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, { class: "section-container" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                        cols: "12",
                        class: "header-with-select-box"
                    }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("h3", { class: "text-primary weight-600" }, "Fax Submission Request", -1)
                            ]))]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                                id: "use-fax-form",
                                modelValue: useFaxForm.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((useFaxForm).value = $event)),
                                disabled: !props.isEditable,
                                color: "accent",
                                "hide-details": "",
                                label: "CHECK THIS BOX TO SEND THIS SUBMISSION OUT OVER FAX on one of your mapped fax forms, instead of the default submission method.",
                                onChange: onOptInChange
                            }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                    }),
                    (useFaxForm.value)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12"
                        }, {
                            default: _withCtx(() => [
                                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-body-3-1 weight-600 text-primary mt-n4 mb-3" }, "Fax form to submit on:", -1)),
                                _createVNode(_component_v_select, {
                                    modelValue: selectedFaxForm.value,
                                    "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event) => ((selectedFaxForm).value = $event)),
                                        onFormSelected
                                    ],
                                    items: props.faxForms,
                                    "item-title": "description",
                                    "item-value": "faxDestination",
                                    readonly: !props.isEditable,
                                    disabled: !props.isEditable,
                                    rules: faxFormRules,
                                    class: "lh--force-white-background",
                                    density: "compact",
                                    placeholder: "Please select a fax form"
                                }, null, 8, ["modelValue", "items", "readonly", "disabled"])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
